// extracted by mini-css-extract-plugin
export default {"container":"screens_container__KP8S7","body":"screens_body__0xrhl"};